import { useLiveQuery } from 'dexie-react-hooks';
import { useEffect, useState } from 'react';
import { currentOwner } from '@/lib/offline/cache';
import { readProjectedBundle } from '@/lib/offline/operations';
import { useAuthStore } from '@/stores/auth';

/** Reutiliza el histórico descargado, con los cambios locales proyectados. */
export function useNaveHistoryBundle() {
  const owner = useAuthStore((s) => s.user?.id ?? null);
  const [version, refresh] = useState(0);
  useEffect(() => {
    const changed = () => refresh((v) => v + 1);
    window.addEventListener('offline:change', changed);
    window.addEventListener('offline:permissions-changed', changed);
    return () => {
      window.removeEventListener('offline:change', changed);
      window.removeEventListener('offline:permissions-changed', changed);
    };
  }, []);
  const result = useLiveQuery(async () => {
    try {
      const bundle = owner == null ? null : await readProjectedBundle();
      return { owner, bundle: currentOwner() === owner ? bundle : null };
    } catch {
      return { owner, bundle: null };
    }
  }, [owner, version]);
  return result?.owner === owner ? result.bundle : null;
}
